import {
  DataLayer,
  delegateClickEvents,
  dataLayerName,
  getDataLayer as getDataLayerImplementation,
} from '@dhl/datalayer'
import { type DataLayerData, type DataLayerMeta } from './types/types.js'

/**
 * Through this method we can initalize the internal datalayer which we used to send data to external providers like Adobe.
 * You should implement this method in the root of your application. For the most generic providers like Adobe it is taken care of
 * the useThirdParty hook, but it also possible to create your own provider in your application.
 */
export const initDataLayer = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any)[dataLayerName] = new DataLayer<DataLayerData, DataLayerMeta>()
  // simple event delegation traversing in the dom tree when target has our meta attribute(s)
  delegateClickEvents()
}

export const getDataLayer: typeof getDataLayerImplementation<DataLayerData, DataLayerMeta> = getDataLayerImplementation<
  DataLayerData,
  DataLayerMeta
>
